import { render, staticRenderFns } from "./projectsResave.vue?vue&type=template&id=49826d07&scoped=true"
import script from "./projectsResave.vue?vue&type=script&lang=js"
export * from "./projectsResave.vue?vue&type=script&lang=js"
import style0 from "./projectsResave.vue?vue&type=style&index=0&id=49826d07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49826d07",
  null
  
)

export default component.exports